import { React, useState, useEffect } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import api from '../../../seller-apis/api';
import { NavLink } from 'react-router-dom';
import PaginationCom from '../../common/Pagination';
import NotAprrPCard from '../../common/NotAprrPCard';
import '../../inventry.css'
import { pendforapprovProducts } from '../../../seller-apis/apidataField';
import ProductCard from '../../common/ProductCard';
import Popup from '../../common/Popup';
import { variables } from '../../../Variables.json'
import ProductSearch from '../../common/ProductSearch';

var globalFilter = {
    "pageNo": 1
};
const AddCatalogue = () => {

    var outerdiv;
    var loaderDiv;

    const [pendingProductsList, setpendingProductsList] = useState([]);
    const [pendRecords, setpendRecords] = useState();
    const [rejRecords, setrejRecords] = useState();

    // Pagination related
    const [selPgPend, setselPgPend] = useState(1);
    const [compforPaginationweb, setcompforPaginationweb] = useState("default")

    // Web search

    const [searchPro, setsearchPro] = useState();

    // Loader
    const [loaderProduct, setloaderProduct] = useState("block")

    // Detail Popup

    const [isDetailPopupVis, setisDetailPopupVis] = useState("none")
    const [currdetailId, setcurrdetailId] = useState(0)

    // VendorId
    const [vendorId, setVendorId] = useState()
    const [searchType, setSearchType] = useState("Product Name");

    const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")

    useEffect(() => {
        globalFilter = {
            "pageNo": 1
        }
        setVendorId(localStorage.getItem('userId'))
        // New request for approval Products
        api.product.vExPrdReqRetrieveAll(pendforapprovProducts(globalFilter))
            .then((res) => {
                setpendingProductsList(res.data)
                setpendRecords(res.totalRecords)
                setloaderProduct("none")
            })
            .catch(err => {
                console.log(err)
            })


    }, [])



    // Search on enter web

    function checkevent(e) {
        if (e.keyCode === 13) {
            globalFilter.productFilters = {
                ...globalFilter.productFilters, "productName": searchPro,
            }
            if (searchPro !== undefined && searchPro !== "") {
                let ordersearchFilter=searchType!='sku'?{"productName": searchPro}:{"SKU": searchPro};
                globalFilter.productFilters = {
                    ...ordersearchFilter,
                }
                applyLoader()
                setselPgPend(1)
                setcompforPaginationweb("filter")
                globalFilter.pageNo = "1"
                api.product.vExPrdReqRetrieveAll(pendforapprovProducts(globalFilter))
                    .then((res) => {
                        setremoveFilterClass("invent_remove_filter_btn_active")
                        setpendingProductsList(res.data)
                        setpendRecords(res.totalRecords)
                        removeLoader()

                    })
                    .catch(err => {
                        console.log(err)
                        removeLoader()
                    })
            }
            else if (compforPaginationweb !== "default") {
                applyLoader()
                globalFilter.pageNo = "1"
                outerdiv.classList.add("div-bk");
                loaderDiv.classList.add("loader-bt");
                globalFilter.filters = {}
                setselPgPend(1)
                api.product.vExPrdReqRetrieveAll(pendforapprovProducts(globalFilter))
                    .then((res) => {
                        setremoveFilterClass("invent_remove_filter_btn")
                        setpendingProductsList(res.data)
                        setpendRecords(res.totalRecords)
                        removeLoader()
                        setcompforPaginationweb("default")
                    })
                    .catch(err => {
                        console.log(err)
                        removeLoader()
                    })
            }
        }
    }

    // search product btn web
    function searchProdBtnweb() {
        globalFilter.productFilters = {
            ...globalFilter.productFilters, "productName": searchPro,
        }
        if (searchPro !== undefined && searchPro !== "") {

            applyLoader()
            setselPgPend(1)
            setcompforPaginationweb("filter")
            globalFilter.pageNo = "1"
            api.product.vExPrdReqRetrieveAll(pendforapprovProducts(globalFilter))
                .then((res) => {
                    setremoveFilterClass("invent_remove_filter_btn_active")
                    setpendingProductsList(res.data)
                    setpendRecords(res.totalRecords)
                    removeLoader()
                })
                .catch(err => {
                    console.log(err)
                    removeLoader()
                })
        }
        else if (compforPaginationweb !== "default") {
            applyLoader()
            globalFilter.pageNo = "1"
            outerdiv.classList.add("div-bk");
            loaderDiv.classList.add("loader-bt");
            globalFilter.filters = {}
            setselPgPend(1)
            api.product.vExPrdReqRetrieveAll(pendforapprovProducts(globalFilter))
                .then((res) => {
                    setremoveFilterClass("invent_remove_filter_btn")
                    setpendingProductsList(res.data)
                    setpendRecords(res.totalRecords)
                    removeLoader()
                    setcompforPaginationweb("default")
                })
                .catch(err => {
                    console.log(err)
                    removeLoader()
                })
        }
    }

    // Pagination function

    function paginate(data) {
        setcurrdetailId(0)
        globalFilter.pageNo = data.number
        setselPgPend(data.number)
        applyLoader()
        api.product.vExPrdReqRetrieveAll(pendforapprovProducts(globalFilter))
            .then((res) => {
                console.log(res)
                setpendingProductsList(res.data)
                removeLoader()
            })
            .catch(err => {
                console.log(err)
                removeLoader()
            })
    }


    // apply loaders

    function applyLoader() {
        outerdiv = document.getElementById("orDeskContain");
        loaderDiv = document.getElementById("Loaderrejected");
        loaderDiv.classList.add("loader-bt");
        setloaderProduct("flex")
        outerdiv.classList.add("div-bk");
    }

    // remove loader

    function removeLoader() {
        loaderDiv.classList.remove("loader-bt");
        setloaderProduct("none")
        outerdiv.classList.remove("div-bk");
    }

    // Show detail

    function showDetail(id) {
        setcurrdetailId(id)
        setisDetailPopupVis("block")
    }

    function setpopupVisibilityDetail() {
        setisDetailPopupVis("none")
    }

    // Clear Filters

    function clearFilters() {
        if (searchPro !== undefined && searchPro !== "") {
            applyLoader()
            setselPgPend(1)
            globalFilter = {
                "pageNo": "1"
            }
            setsearchPro("")

            api.product.vExPrdReqRetrieveAll(pendforapprovProducts(globalFilter))
                .then((res) => {
                    setremoveFilterClass("invent_remove_filter_btn")
                    setcompforPaginationweb("default")
                    setpendingProductsList(res.data)
                    setpendRecords(res.totalRecords)
                    removeLoader()
                })
                .catch(err => {
                    console.log(err)
                    removeLoader()
                })

        }
    }
    const filterSearch=(data)=>{
        setsearchPro(data.data);
        setSearchType(data.type)
      }
    
      useEffect(()=>{
        checkevent({ "keyCode": 13 }, "appPro");
      },[searchPro])
    return (
        <div className=" inventry-page" id="outer">
            <div className='pro_filt_cntnier_new_request d-flex'>
                {/* <button className={removeFilterClass} onClick={() => clearFilters()}>Clear Filter</button> */}
                <div className='topprodsearch'>
                        {/* <ProductSearch 
                        filterSearch={filterSearch}
                        searchNewEnq={setsearchPro}
                        /> */}
                </div>
                {/* <div class="">
                      <select className="pro_approved_srch_bar pr-4" onChange={(e)=>{setSearchType(e.target.value)}}>
                        <option value="product Name">Product Name</option>
                        <option value="sku">SKU</option>
                      </select>
                    </div>
                <input type='text' value={searchPro} placeholder='Search for products...' className='pro_approved_srch_bar pr-4' onKeyUp={(e) => checkevent(e)} onChange={(e) => setsearchPro(e.target.value)}></input><i className="fa fa-search srch_pro_filt_invent" aria-hidden="true" onClick={() => searchProdBtnweb()}></i> */}

                <NavLink exact to="/add-Product1">
                    <button className='pro_add_pro_invent ms-2'>+ Add Product</button>
                </NavLink>
            </div>

            <div className="container_invent" id="orDeskContain">


                {/* New orders desktop */}
                <div class="tab table-responsive">
                    {/* <Container> */}



                    <table className='ord_table' style={{ "width": "100%" }}>
                        <thead>
                            <tr className='table_ord_title_row'>

                                <th className='thead_title pt-2 pb-2' style={{ "width": "5%" }}>Product Image

                                </th>

                                <th className='thead_title pb-1' style={{ "width": "20%" }}>Product Name<br></br>

                                </th>

                                <th className='thead_title' style={{ "width": "7%" }}>Transfer price  <OverlayTrigger
                                    key="transfer"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id={`tooltip-transfer`} className="fs-10 order_page_tooltip">
                                            <p className='fs-8 f-500 order_page_tooltip_1'>{variables.transferPriceText}</p>
                                        </Tooltip>
                                    }
                                >
                                    <i class="bi bi-info-circle ms-1"></i>
                                </OverlayTrigger></th>

                                <th className='thead_title' style={{ "width": "10%" }}>Requested On</th>

                                <th className='thead_title' style={{ "width": "10%" }}>Action</th>
                            </tr>

                        </thead>
                        <tbody>
                            {pendRecords > 0 ? pendingProductsList.map((item, index) => {
                                let baseImg;
                                let taxClass = item.product.taxClass
                                item.product.images.map((item) => {
                                    if (item.baseImage === true) {
                                        if (item.image.startsWith("products")) {
                                            baseImg = item.image;
                                        }
                                        else if (item.image.startsWith("https:")) {
                                            let img = item.image.substr("41")
                                            baseImg = img;
                                        }
                                        else {
                                            baseImg = item.image;
                                        }
                                    }
                                })
                                let date = new Date(item.updatedAt);
                                let d = date.toUTCString(item.updatedAt);
                                let newd = d.substr(4, 12);
                                item.product.vendors && item.product.vendors.map((vitem,vindex)=>{
                                    if(vendorId === vitem.vendor_id){
                                        if(vitem.taxClass && vitem.taxClass !== undefined && vitem.taxClass !== ""){
                                            taxClass = vitem.taxClass
                                        }
                                    }
                                })
                                if (item.combination && item.combination.url && item.combination.url !== undefined && item.combination.url !== "" && item.combination.url !== "notfound") {
                                    var combarry = [];
                                    var singleAttr = true;
                                    if (item.product.combination[0] && item.product.combination[0].value && item.product.combination[0].value.length > 1) {
                                        singleAttr = false
                                    }
                                    let obj = [];
                                    item.product.combination.map((pitem, pindex) => {
                                        if (pitem.url === item.combination.url && item.combination.purchase_price && item.combination.purchase_price !== undefined) {
                                            if (!singleAttr) {
                                                let com = "";
                                                pitem.value.map((aitem, aindex) => {
                                                    com = com + aitem;
                                                    if (aindex !== pitem.value.length - 1) {
                                                        com = com + " x "
                                                    }
                                                })
                                                combarry.push({ "com": com, "price": item.combination.purchase_price })
                                            }
                                            else {
                                                let com = { "com": pitem.value[0], "price": item.combination.purchase_price }
                                                combarry.push(com)
                                            }
                                        }
                                    })

                                    return (
                                        <ProductCard id={index}
                                            taxClass={taxClass}
                                            SKU={item.product.SKU}
                                            updatedon={newd}
                                            urlKey={item.urlKey}
                                            lowestPrice={item.lowestPrice}
                                            shortDescription={item.shortDescription}
                                            lead={item._id}
                                            productName={item.product.productName}
                                            price={item.purchase_price}
                                            status={item.status}
                                            detail={showDetail}
                                            requestFrom="inventory"
                                            combination={combarry}
                                            image={baseImg}
                                        />
                                    )
                                }
                                else {
                                    return (
                                        <ProductCard id={index}
                                            taxClass={taxClass}
                                            SKU={item.product.SKU}
                                            detail={showDetail}
                                            updatedon={newd}
                                            urlKey={item.urlKey}
                                            lowestPrice={item.lowestPrice}
                                            shortDescription={item.shortDescription}
                                            lead={item._id}
                                            productName={item.product.productName}
                                            price={item.purchase_price}
                                            status={item.status}
                                            requestFrom="inventory"
                                            image={baseImg}
                                        />
                                    )
                                }
                            }) :
                                loaderProduct === "block" ? <></> :
                                    <div className="card card-1 ">
                                        Nothing here.
                                    </div>}

                        </tbody>
                    </table>
                    {/* </Container> */}
                </div>

                <PaginationCom
                    number={pendRecords}
                    paginate={paginate}
                    comp="pendingPro"
                    activ={selPgPend}
                />
                <div class="d-flex justify-content-center loader-bt" id="Loaderrejected">
                    <div class="spinner-border" role="status" style={{ "display": loaderProduct }}>
                        <span class="sr-only"></span>
                    </div>
                </div>

                {/* Detail popup */}
                {pendingProductsList.length > 0 ? <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
                    <Popup
                        description={pendingProductsList[currdetailId].product.description}
                        sdescription={pendingProductsList[currdetailId].product.shortDescription}
                        descriptionNew={pendingProductsList[currdetailId].product?.descriptionNew||[]}
                        specificationNew={pendingProductsList[currdetailId].product?.specificationNew||[]}
                        name={pendingProductsList[currdetailId].product.productName}
                        // price={detailPPrice}
                        SKU={pendingProductsList[currdetailId].product.SKU}
                        popupVisibility={setpopupVisibilityDetail}
                        images={pendingProductsList[currdetailId].product.images}
                    />
                </div> : <></>
                }

            </div>


        </div>
    )
}

export default AddCatalogue